import { Button, Menu, MenuItem, Box } from "@mui/material";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { toastMessage } from "../../utils/toast";
import GenerateSlotsModal from "./GenerateSlotsModal";
import DeleteSlotModal from "./DeleteSlotModal";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { setSelectedIds } from "../../Redux/reducers/appointmentSlice";

interface AppointmentActionsProps {
  viewMode: "slots" | "cancelled";
  onToggleSlots: () => void;
  onToggleViewMode: () => void;
  onManualAppointment: () => void;
}

const AppointmentActions = ({
  viewMode,
  onToggleSlots,
  onToggleViewMode,
  onManualAppointment,
}: AppointmentActionsProps) => {
  const dispatch = useAppDispatch();
  const selectedIds = useAppSelector((state) => state.appointment.selectedIds);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const open = Boolean(anchorEl);

  const handleActionClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleActionClose = () => {
    setAnchorEl(null);
  };

  const openGenerateModal = () => {
    if (!sessionStorage.getItem("reg_appt_room")) {
      toastMessage("warning", "Please select a room first");
      return;
    }
    handleActionClose();
    setShowGenerateModal(true);
  };

  const handleManualAppointment = () => {
    if (!sessionStorage.getItem("reg_appt_room")) {
      toastMessage("warning", "Please select a room first");
      return;
    }
    handleActionClose();
    onManualAppointment();
  };

  const handleToggleViewMode = () => {
    if (!sessionStorage.getItem("reg_appt_room")) {
      toastMessage("warning", "Please select a room first");
      return;
    }
    handleActionClose();
    onToggleViewMode();
  };

  const closeGenerateModal = () => {
    setShowGenerateModal(false);
  };

  const handleClearSelected = () => {
    dispatch(setSelectedIds([]));
  };

  const handleDeleteSelected = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteSuccess = () => {
    dispatch(setSelectedIds([]));
    onToggleSlots();
    setShowDeleteModal(false);
  };

  if (selectedIds.length > 0) {
    return (
      <>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button variant="outlined" onClick={handleClearSelected}>
            Clear Selected ({selectedIds.length})
          </Button>
          <Button variant="contained" color="error" onClick={handleDeleteSelected}>
            Delete Selected ({selectedIds.length})
          </Button>
        </Box>

        {showDeleteModal && (
          <DeleteSlotModal
            show={showDeleteModal}
            onClose={handleDeleteModalClose}
            slotIds={selectedIds}
            roomId={sessionStorage.getItem("reg_appt_room") || ""}
            refresh={handleDeleteSuccess}
          />
        )}
      </>
    );
  }

  return (
    <>
      <Button
        variant="contained"
        onClick={handleActionClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Actions
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleActionClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        TransitionProps={{
          exit: false,
        }}
      >
        <MenuItem onClick={openGenerateModal}>Generate Slots</MenuItem>
        <MenuItem onClick={handleManualAppointment}>
          Manual Appointment
        </MenuItem>
        <MenuItem onClick={handleToggleViewMode}>
          {viewMode === "slots" ? "View Cancelled" : "View Slots"}
        </MenuItem>
      </Menu>

      {showGenerateModal && (
        <GenerateSlotsModal
          open={showGenerateModal}
          onClose={closeGenerateModal}
          refresh={onToggleSlots}
        />
      )}
    </>
  );
};

export default AppointmentActions;
